import { TrackingPageFeedbackModalComponent } from './tracking-page-feedback-modal/tracking-page-feedback-modal.component';

export const MODALS = [TrackingPageFeedbackModalComponent];

export { TrackingPageFeedbackModalComponent };
